// The depth composite as a PASS, so it stops competing for the frame.
//
// THE BUG THIS EXISTS TO FIX (owner, 2026-09-20): "the 3D effects don't work
// if I hover the mouse over the geometry, and only work if I move the mouse
// away from any fragments." The composite and the composer each OWNED the
// frame - the composite drew a prepass, rendered the picture into its own
// target and put the result on the canvas; the composer ran RenderPass then
// OutlinePass onto the canvas - so the render loop had to choose, and it
// chose the composer the moment anything was outlined. Hovering outlines
// something. So the effects vanished under the pointer and came back when it
// moved off geometry.
//
// A PREDICTION THAT WOULD HAVE DISPROVED THIS, kept because a stated way to
// be wrong is worth more than a confident explanation: this explains the
// DEPTH-AWARE composite dropping and NOT the cheap edge/contact shading,
// which lives in the materials (onBeforeCompile) and survives every render
// path. If the effects had vanished on hover with Depth-aware OFF, the
// diagnosis was wrong. The owner confirmed Depth-aware was ON.
//
// The fix is structural rather than a hover special-case: the composite
// renders into the composer's buffer instead of onto the canvas, and the
// outline pass then draws over the composited picture exactly as it draws
// over a RenderPass picture. One owner, no choice to get wrong.
import { Pass } from 'three/examples/jsm/postprocessing/Pass';

export default class CompositePass extends Pass {
  constructor(composite, scene, camera) {
    super();
    this.composite = composite;
    this.scene = scene;
    this.camera = camera;
    // Like RenderPass: this pass FILLS the read buffer rather than
    // transforming it, so the chain must not swap after it.
    this.needsSwap = false;
    // Set by the viewer each frame; the composite holds its prepass while
    // the camera is moving (freezeWhileMoving).
    this.moving = false;
  }

  render(renderer, writeBuffer, readBuffer) {
    const target = this.renderToScreen ? null : readBuffer;
    const drew = this.composite
      && this.composite.render(this.scene, this.camera, { moving: !!this.moving, target });
    // The composite declines when it is switched off. Without this the
    // frame would be BLANK rather than merely un-shaded, which is the
    // worst possible way for a toggle to fail - so fall back to drawing
    // the scene exactly as RenderPass would.
    if (!drew) {
      renderer.setRenderTarget(target);
      renderer.clear(true, true, true);
      renderer.render(this.scene, this.camera);
      renderer.setRenderTarget(null);
    }
  }

  // The composite sizes its own targets from the drawing buffer on every
  // render, so there is nothing to do here - but Pass requires the method.
  setSize() {}
}
